import SendVerificationCode from './SendVerificationCode'
export default SendVerificationCode
